module.exports = __webpack_public_path__ + "img/cz.520c426c.svg";